import { Component, inject } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';
import { SessionStore } from './store/session.store';
import { PosthogService } from './features/shared/services/posthog.service';
@UntilDestroy()
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: false,
})
export class AppComponent {
	private _router = inject(Router);
	private _viewportScroller = inject(ViewportScroller);
	private _session = inject(SessionStore);
	private _posthog = inject(PosthogService);

	constructor() {
		this._session.initialize();

		this._router.events
			.pipe(
				untilDestroyed(this),
				filter((event): event is NavigationStart => event instanceof NavigationStart),
			)
			.subscribe((event) => {
				if (event.url === '/') {
					this._router.navigate(['/network/dashboard']);
				}
				if (event.url.startsWith('/auth/')) {
					return;
				}
			});

		this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
			if (this.shouldBlockScroll(event.urlAfterRedirects)) {
				return;
			}
			this._viewportScroller.scrollToPosition([0, 0]);
		});
	}

	private shouldBlockScroll(url: string): boolean {
		return BLOCK_SCROLL_ROUTES.some((route) => url.includes(route));
	}
}

const BLOCK_SCROLL_ROUTES = ['/insights/tickets', '/insights/performance'];
